<template>
  <div>
    <navbar></navbar>
    <gd-aside></gd-aside>
    <main class="gd-main gd-bckg-very-light-grey">
      <div class="main-layout">
        <h1>Liste des drivers</h1>
        <div class="gd-vertical-small-padding-layout">
          <div class="gd-label">Rechercher :</div>
          <input
            type="text"
            class="gd-input-text"
            placeholder="Nom du driver"
            id="searchdriverName" @keydown.enter="search('driverName')">
          <span class="gd-m-h-5">
            <button id="searchdriverName" class="gd-rounded-btn" @click="search('driverName')">
              <IconResearch class="gd-rounded-btn__icon"></IconResearch>
            </button>
            <button id="resetdriverName"
              @click="resetSearch('driverName')"
              class="gd-rounded-btn gd-rounded-btn--small gd-hidden">
              <IconClose class="gd-rounded-btn__icon"></IconClose>
            </button>
          </span>
          <input
            type="text"
            class="gd-input-text"
            placeholder="Nom du client"
            id="searchclientName" @keydown.enter="search('clientName')">
          <span class="gd-m-h-5">
            <button class="gd-rounded-btn" @click="search('clientName')">
              <IconResearch class="gd-rounded-btn__icon"></IconResearch>
            </button>
            <button
              id="resetclientName"
              @click="resetSearch('clientName')"
              class="gd-rounded-btn gd-rounded-btn--small gd-hidden">
              <IconClose class="gd-rounded-btn__icon"></IconClose>
            </button>
          </span>
        </div>
        <i class="loader" v-if="loadingDrivers"></i>
        <table class="gd-table" v-else-if="!cardView">
          <thead class="gd-table__header">
            <tr>
              <td class="gd-table__header-cell gd-table__cell"
                v-for="head in header"
                :key="`head${head.name}`">
                {{ head.name }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="object in objects"
              :key="`driver${object.driver.id}`"
              @click="goTo({ name: 'driver', params: { id: object.driver.id } })"
              class="gd-table__row" :class="{ 'in-error' : object.driver.inErrorState }">
              <td class="gd-table__cell">
                <span class="gd-tag gd-tag--red" v-if="object.driver.inErrorState">Erreur</span>
                {{ object.driver.name }}
              </td>
              <td class="gd-table__cell">{{ object.driver.id }}</td>
              <td class="gd-table__cell gd-table__cell--tag-cell">
                <span class="gd-tag">{{ object.driver.version }}</span>
              </td>
              <td class="gd-table__cell">{{ object.driver.macAddress }}</td>
              <td class="gd-table__cell">{{ object.driver.clientName }}</td>
              <td class="gd-table__cell">{{ object.totalPrinting }}</td>
              <td class="gd-table__cell">{{ object.printingErrors }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="gd-table__cell gd-table__footer-cell" :colspan="header.length">
                <pagination
                  :current="1"
                  :total="driversParams.total"
                  :limit="driversParams.count"
                  v-if="driversParams.total"
                  @pageChange="pageChange"></pagination>
              </td>
            </tr>
          </tfoot>
        </table>
        <div v-else class="gd-small-padding-layout">
          <card
            v-for="object in objects"
            :object="object"
            :labels="cardLabels"
            :key="`card${object.driver.id}`"
            :title="object.driver.name"
            :class="{ 'in-error' : object.driver.inErrorState }"
            @click.native="goTo({ name: 'driver', params: { id: object.driver.id } })">
          </card>
          <div class="gd-small-padding-layout gd-bckg-light-grey gd-bold gd-text-center">
            <pagination
              :current="1"
              :total="driversParams.total"
              :limit="driversParams.count"
              v-if="driversParams.total"
              @pageChange="pageChange">
            </pagination>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Aside from '@/components/Aside';
import Card from '@/components/Card';
import IconClose from '@/assets/svg/icon-close.svg';
import IconResearch from '@/assets/svg/icon-research.svg';
import IconUpdate from '@/assets/svg/icon-update.svg';
import Navbar from '@/components/Navbar';
import Pagination from '@/components/Pagination';

import { mapActions } from 'vuex';

export default {
  name: 'Home',

  components: {
    'gd-aside': Aside,
    Card,
    IconClose,
    IconResearch,
    IconUpdate,
    Navbar,
    Pagination,
  },

  data() {
    return {
      objects: [],
      header: [
        { name: 'Nom' },
        { name: 'Id driver' },
        { name: 'Version' },
        { name: 'Adresse MAC' },
        { name: 'Nom du client' },
        { name: 'Nombre d\'impressions' },
        { name: 'Erreurs d\'impressions' },
      ],
      cardLabels: [
        { name: 'Id driver', reference: 'driver.id' },
        { name: 'Version', reference: 'driver.version' },
        { name: 'Adresse MAC', reference: 'driver.macAddress' },
        { name: 'Nom du client', reference: 'driver.clientName' },
        { name: 'Nombre d\'impressions', reference: 'totalPrinting' },
        { name: 'Erreurs d\'impressions', reference: 'printingErrors' },
      ],
      asideOpen: false,
      cardView: false,
      driversParams: {
        from: 0,
        count: 5,
        total: undefined,
        driverName: undefined,
        clientName: undefined,
      },
      loadingDrivers: false,
    };
  },

  methods: {
    ...mapActions({
      getDrivers: 'drivers/getDrivers',
      routeVIP: 'drivers/routeVIP',
      apiOpenSnackbar: 'app/openSnackbar',
    }),

    goTo(route) {
      this.$router.push(route);
    },

    swicthViewMobileGestion() {
      if (window.matchMedia('(max-width: 991px)').matches) {
        this.cardView = true;
      } else {
        this.cardView = false;
      }
    },

    pageChange(offset) {
      this.driversParams.from = offset;
      this.loadingDrivers = true;
      this.getDrivers(this.driversParams)
        .then((data) => {
          this.loadingDrivers = false;
          this.objects = data.drivers;
        });
    },

    search(paramName) {
      const searchValue = document.getElementById(`search${paramName}`).value;
      document.getElementById(`reset${paramName}`).classList.remove('gd-hidden');
      this.driversParams[paramName] = searchValue;
      this.loadingDrivers = true;
      this.getDrivers(this.driversParams)
        .then((data) => {
          this.loadingDrivers = false;
          this.objects = data.drivers;
          this.driversParams.total = data.total;
        });
    },

    resetSearch(paramName) {
      document.getElementById(`search${paramName}`).value = '';
      document.getElementById(`reset${paramName}`).className += ' gd-hidden';
      delete this.driversParams[paramName];
      this.loadingDrivers = true;
      this.getDrivers(this.driversParams)
        .then((data) => {
          this.loadingDrivers = false;
          this.objects = data.drivers;
          this.driversParams.total = data.total;
        });
    },
  },

  mounted() {
    this.swicthViewMobileGestion();
    window.addEventListener('resize', () => {
      this.swicthViewMobileGestion();
    });
    this.loadingDrivers = true;
    this.getDrivers(this.driversParams)
      .then((data) => {
        this.loadingDrivers = false;
        this.objects = data.drivers;
        this.driversParams.total = data.total;
        /* console.log(data);
        for (let i = 0; i < data.drivers.length; i += 1) {
          this.routeVIP(data.drivers[i].driver.id);
        } */
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue